const STORAGE_KEY = 'hub.permissionsUiVersion';

export const getPermissionsUiPreference = () => localStorage.getItem(STORAGE_KEY) || 'classic';

export const setPermissionsUiPreference = version => {
  localStorage.setItem(STORAGE_KEY, version);
};
